(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Butelka-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  function shopRoot(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function initGallery(sec){
    var stage=sec.querySelector('[data-stage]'); if(!stage) return;
    var slides=Array.prototype.slice.call(stage.children);
    var thumbs=Array.prototype.slice.call(sec.querySelectorAll('[data-thumb]'));
    thumbs.forEach(function(btn){
      btn.addEventListener('click',function(){
        var idx=parseInt(btn.getAttribute('data-idx'),10)||0;
        if(slides[idx]) slides[idx].scrollIntoView({behavior:'smooth',inline:'center',block:'nearest'});
      });
    });
    if(thumbs.length>1){
      stage.addEventListener('scroll',function(){
        var c=stage.getBoundingClientRect();var center=c.left+c.width/2;var best=0,bd=Infinity;
        slides.forEach(function(s,i){var r=s.getBoundingClientRect();var d=Math.abs(r.left+r.width/2-center);if(bd>d){bd=d;best=i;}});
        thumbs.forEach(function(b){b.classList.toggle('is-active',(parseInt(b.getAttribute('data-idx'),10)||0)===best);});
      },{passive:true});
    }
  }
  function openDrawer(){
    var drawer=document.querySelector('cart-drawer');
    if(!drawer){window.location.href=shopRoot()+'cart';return;}
    try{ if(typeof drawer.open==='function'){drawer.open();} else {drawer.classList.remove('is-empty');drawer.classList.add('animate','active');document.body.classList.add('overflow-hidden');} }
    catch(e){ drawer.classList.add('animate','active');document.body.classList.add('overflow-hidden'); }
  }
  function refreshDrawer(){
    var wrap=document.getElementById('shopify-section-cart-drawer');
    return fetch(shopRoot()+'?section_id=cart-drawer',{headers:{'Accept':'text/html'}})
      .then(function(r){return r.text();})
      .then(function(html){ if(wrap){wrap.innerHTML=html;} })
      .then(function(){ return fetch(shopRoot()+'?section_id=cart-icon-bubble').then(function(r){return r.text();}).then(function(h){var b=document.getElementById('shopify-section-cart-icon-bubble');if(b){b.innerHTML=h;}}).catch(function(){}); })
      .catch(function(){});
  }
  function initAtc(form){
    if(form.dataset.buReady) return; form.dataset.buReady='1';
    var btn=form.querySelector('button[type="submit"]');
    var err=form.querySelector('[data-butelka-atc-err]');
    form.addEventListener('submit',function(e){
      e.preventDefault();
      if(err){err.hidden=true;err.textContent='';}
      if(btn){btn.classList.add('is-loading');btn.disabled=true;}
      fetch(form.getAttribute('action'),{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:new FormData(form)})
        .then(function(r){return r.json().then(function(j){return {ok:r.ok,body:j};});})
        .then(function(res){ if(!res.ok){ if(err){err.hidden=false;err.textContent=(res.body&&res.body.description)||'Nie udało się dodać do koszyka.';} return; } return refreshDrawer().then(openDrawer); })
        .catch(function(){ if(err){err.hidden=false;err.textContent='Wystąpił błąd sieci. Spróbuj ponownie.';} })
        .finally(function(){ if(btn){btn.classList.remove('is-loading');btn.disabled=false;} });
    });
  }
  function boot(scope){ var s=scope||document; s.querySelectorAll('.Butelka-product').forEach(initGallery); s.querySelectorAll('[data-butelka-atc]').forEach(initAtc); }
  if(document.readyState!=='loading'){boot();}else{document.addEventListener('DOMContentLoaded',function(){boot();});}
  document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batonik-koszyk"] && !Shopify.designMode) return;
  try {
    
(function () {
  var cfgEl = document.querySelector('[data-btk-koszyk-config]');
  if (!cfgEl) return; /* sekcji nie ma w szablonie tej strony — koszyk zostaje bez zmian */

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var KLUCZ = 'btk-koszyk-koniec';
  var obserwator = null;
  var tykanie = null;
  var ostatniKoszyk = null;

  function szuflada() { return document.querySelector('cart-drawer'); }

  function kwota(grosze) {
    var liczba = (grosze / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    var bezGroszy = Math.round(grosze / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return String(cfg.formatKwoty || '{' + '{amount}' + '} zł')
      .replace(/\{\{\s*amount_no_decimals[a-z_]*\s*\}\}/, bezGroszy)
      .replace(/\{\{\s*amount[a-z_]*\s*\}\}/, liczba)
      .replace(/<[^>]+>/g, '');
  }

  /* ── Licznik czasu: jeden na sesję, po upływie zaczyna od nowa ── */
  function koniec() {
    var teraz = Date.now();
    var zapis = 0;
    try { zapis = parseInt(window.sessionStorage.getItem(KLUCZ), 10) || 0; } catch (e) { zapis = 0; }
    if (!zapis || zapis <= teraz) {
      zapis = teraz + (cfg.timerMinuty || 10) * 60 * 1000;
      try { window.sessionStorage.setItem(KLUCZ, String(zapis)); } catch (e) {}
    }
    return zapis;
  }

  function tik() {
    var pola = document.querySelectorAll('[data-btk-ko-zegar]');
    if (!pola.length) return;
    var sek = Math.max(0, Math.floor((koniec() - Date.now()) / 1000));
    var m = Math.floor(sek / 60);
    var s = sek % 60;
    var tekst = (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
    pola.forEach(function (p) { if (p.textContent !== tekst) p.textContent = tekst; });
  }

  /* ── Odświeżenie szuflady motywu po zmianie koszyka z naszych przycisków ── */
  function przerysuj(stan) {
    var d = szuflada();
    if (d && typeof d.renderContents === 'function' && stan && stan.sections) {
      d.renderContents(stan);
      d.classList.remove('is-empty');
    } else {
      window.location.reload();
    }
  }

  function idSekcji() {
    var d = szuflada();
    if (d && typeof d.getSectionsToRender === 'function') {
      return d.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function wyslij(url, dane) {
    dane.sections = idSekcji();
    dane.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(dane)
    }).then(function (r) { return r.json(); });
  }

  /* ── Budowanie elementów ── */
  function zbudujTimer() {
    var p = document.createElement('p');
    p.className = 'btk-ko-timer';
    p.setAttribute('data-btk-ko', 'timer');
    var czesci = String(cfg.timerTekst || 'Twój koszyk wygasa za [timer] min!').split('[timer]');
    p.appendChild(document.createTextNode(czesci[0]));
    var zegar = document.createElement('strong');
    zegar.setAttribute('data-btk-ko-zegar', '');
    zegar.textContent = '--:--';
    p.appendChild(zegar);
    if (czesci.length > 1) p.appendChild(document.createTextNode(czesci[1]));
    return p;
  }

  function zbudujDostawe() {
    var w = document.createElement('div');
    w.className = 'btk-ko-dostawa';
    w.setAttribute('data-btk-ko', 'dostawa');
    w.innerHTML = '<p class="btk-ko-dostawa__txt" data-btk-ko-dostawa-txt></p>' +
      '<div class="btk-ko-dostawa__tor"><div class="btk-ko-dostawa__pasek" data-btk-ko-dostawa-pasek></div></div>';
    return w;
  }

  function wstawTekstZPogrubieniem(el, tekst) {
    /* **fragment** → <strong>fragment</strong>, bez innerHTML z treści ustawień */
    el.textContent = '';
    String(tekst).split('**').forEach(function (cz, i) {
      if (!cz) return;
      if (i % 2) {
        var s = document.createElement('strong');
        s.textContent = cz;
        el.appendChild(s);
      } else {
        el.appendChild(document.createTextNode(cz));
      }
    });
  }

  function ustawDostawe(d, koszyk) {
    var txt = d.querySelector('[data-btk-ko-dostawa-txt]');
    var pasek = d.querySelector('[data-btk-ko-dostawa-pasek]');
    if (!txt || !pasek || !koszyk) return;
    var prog = cfg.progGrosze || 0;
    var suma = koszyk.total_price || 0;
    var brak = prog - suma;
    var tekst = brak > 0
      ? String(cfg.dostawaBrakuje || '').replace('[kwota]', kwota(brak))
      : String(cfg.dostawaSukces || '');
    if (txt.getAttribute('data-tekst') !== tekst) {
      txt.setAttribute('data-tekst', tekst);
      wstawTekstZPogrubieniem(txt, tekst);
    }
    pasek.style.width = (prog > 0 ? Math.min(100, Math.round((suma / prog) * 100)) : 100) + '%';
  }

  function zbudujUpsell(d) {
    var szablon = document.querySelector('[data-btk-koszyk-upsell]');
    if (!szablon) return null;
    var w = document.createElement('div');
    w.className = 'btk-ko-upsell';
    w.setAttribute('data-btk-ko', 'upsell');
    if (cfg.upsellNaglowek) {
      var h = document.createElement('p');
      h.className = 'btk-ko-upsell__h';
      h.textContent = cfg.upsellNaglowek;
      w.appendChild(h);
    }
    var ile = 0;
    szablon.content.querySelectorAll('.btk-ko-up').forEach(function (k) {
      var handle = k.getAttribute('data-handle');
      if (d.querySelector('.cart-item--product-' + handle)) return; /* już w koszyku */
      w.appendChild(k.cloneNode(true));
      ile++;
    });
    return ile ? w : null;
  }

  function zbudujRabat() {
    var w = document.createElement('div');
    w.className = 'btk-ko-rabat';
    w.setAttribute('data-btk-ko', 'rabat');
    var rzad = document.createElement('div');
    rzad.className = 'btk-ko-rabat__rzad';
    var pole = document.createElement('input');
    pole.type = 'text';
    pole.className = 'btk-ko-rabat__pole';
    pole.placeholder = cfg.rabatPlaceholder || 'Kod rabatowy';
    pole.setAttribute('aria-label', cfg.rabatPlaceholder || 'Kod rabatowy');
    pole.setAttribute('autocomplete', 'off');
    pole.setAttribute('data-btk-ko-kod', '');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btk-ko-rabat__btn';
    btn.setAttribute('data-btk-ko-zastosuj', '');
    btn.textContent = cfg.rabatPrzycisk || 'Zastosuj';
    rzad.appendChild(pole);
    rzad.appendChild(btn);
    var blad = document.createElement('p');
    blad.className = 'btk-ko-rabat__blad';
    blad.setAttribute('role', 'alert');
    blad.setAttribute('data-btk-ko-blad', '');
    w.appendChild(rzad);
    w.appendChild(blad);
    return w;
  }

  /* ── Nałożenie na szufladę (idempotentne) ── */
  function ubierz() {
    var d = szuflada();
    if (!d) return;
    d.classList.add('btk-koszyk');
    d.classList.toggle('btk-koszyk--bez-sumy', !!cfg.ukryjPodsumowanie);
    d.classList.toggle('btk-koszyk--platnosci', !!cfg.pokazPlatnosci);

    var naglowek = d.querySelector('.drawer__header .drawer__heading');
    if (naglowek && cfg.tytul) {
      var moj = naglowek.querySelector('[data-btk-ko-tytul]');
      if (!moj) {
        naglowek.childNodes.forEach(function (n) {
          if (n.nodeType === 3 && n.textContent.trim()) n.textContent = '';
        });
        moj = document.createElement('span');
        moj.setAttribute('data-btk-ko-tytul', '');
        naglowek.appendChild(moj);
      }
      if (moj.textContent !== cfg.tytul) moj.textContent = cfg.tytul;
    }

    var tresc = d.querySelector('.cart-drawer__body');
    if (tresc) {
      if (cfg.pokazTimer && !tresc.querySelector('[data-btk-ko="timer"]')) {
        tresc.insertBefore(zbudujTimer(), tresc.firstChild);
      }
      if (cfg.pokazDostawa && !tresc.querySelector('[data-btk-ko="dostawa"]')) {
        var timer = tresc.querySelector('[data-btk-ko="timer"]');
        tresc.insertBefore(zbudujDostawe(), timer ? timer.nextSibling : tresc.firstChild);
      }
      var stary = tresc.querySelector('[data-btk-ko="upsell"]');
      if (stary) stary.remove();
      var up = zbudujUpsell(d);
      if (up) tresc.appendChild(up);
    }

    var stopka = d.querySelector('.drawer__footer');
    if (stopka) {
      if (cfg.pokazRabat && !stopka.querySelector('[data-btk-ko="rabat"]')) {
        stopka.insertBefore(zbudujRabat(), stopka.firstChild);
      }
      if (cfg.pokazPlatnosci && !stopka.querySelector('.btk-ko-platnosci')) {
        var szablon = document.querySelector('[data-btk-koszyk-platnosci]');
        if (szablon) stopka.appendChild(szablon.content.cloneNode(true));
      }
    }

    ustawZKoszyka(d, ostatniKoszyk);
    tik();
  }

  function ustawZKoszyka(d, koszyk) {
    if (!koszyk) return;
    if (cfg.pokazDostawa) ustawDostawe(d, koszyk);
    var etykieta = d.querySelector('#CartDrawer-Checkout .button__label') || d.querySelector('#CartDrawer-Checkout');
    if (etykieta && cfg.checkoutTekst) {
      var napis = cfg.checkoutTekst + (cfg.kwotaNaPrzycisku ? ' • ' + kwota(koszyk.total_price) : '');
      if (etykieta.textContent.trim() !== napis) etykieta.textContent = napis;
    }
  }

  function pobierzKoszyk() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (k) { ostatniKoszyk = k; return k; })
      .catch(function () { return null; });
  }

  /* Własne zmiany w DOM nie mogą budzić obserwatora — odłączamy go na czas pracy. */
  function odswiez(zKoszykiem) {
    var d = szuflada();
    if (!d) return;
    if (obserwator) obserwator.disconnect();
    ubierz();
    if (obserwator) obserwator.observe(d, { childList: true, subtree: true });
    if (zKoszykiem) {
      pobierzKoszyk().then(function (k) {
        var dd = szuflada();
        if (!dd || !k) return;
        if (obserwator) obserwator.disconnect();
        ustawZKoszyka(dd, k);
        if (obserwator) obserwator.observe(dd, { childList: true, subtree: true });
      });
    }
  }

  /* ── Kliknięcia: dodanie produktu uzupełniającego, kod rabatowy ── */
  document.addEventListener('click', function (e) {
    var dodaj = e.target.closest ? e.target.closest('[data-btk-ko-dodaj]') : null;
    if (dodaj) {
      var karta = dodaj.closest('.btk-ko-up');
      var vid = karta && parseInt(karta.getAttribute('data-vid'), 10);
      if (!vid) return;
      dodaj.disabled = true;
      wyslij('/cart/add.js', { items: [{ id: vid, quantity: 1 }] })
        .then(function (stan) {
          if (stan && stan.status) { dodaj.disabled = false; return; }
          przerysuj(stan);
        })
        .catch(function () { dodaj.disabled = false; });
      return;
    }

    var zastosuj = e.target.closest ? e.target.closest('[data-btk-ko-zastosuj]') : null;
    if (zastosuj) {
      var blok = zastosuj.closest('.btk-ko-rabat');
      var pole = blok.querySelector('[data-btk-ko-kod]');
      var blad = blok.querySelector('[data-btk-ko-blad]');
      var kod = (pole.value || '').trim();
      blad.textContent = '';
      if (!kod) { pole.focus(); return; }
      zastosuj.disabled = true;
      wyslij('/cart/update.js', { discount: kod })
        .then(function (stan) {
          zastosuj.disabled = false;
          var kody = (stan && stan.discount_codes) || [];
          var ok = kody.some(function (k) { return String(k.code).toLowerCase() === kod.toLowerCase() && k.applicable; });
          if (!ok) {
            blad.textContent = cfg.rabatBlad || 'Ten kod jest nieprawidłowy lub nie dotyczy koszyka.';
            /* błędny kod nie zostaje przypięty do koszyka — zostawiamy tylko działające */
            var dzialajace = kody.filter(function (k) { return k.applicable; }).map(function (k) { return k.code; }).join(',');
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ discount: dzialajace })
            }).catch(function () {});
            return;
          }
          przerysuj(stan);
        })
        .catch(function () {
          zastosuj.disabled = false;
          blad.textContent = cfg.rabatBlad || 'Ten kod jest nieprawidłowy lub nie dotyczy koszyka.';
        });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-btk-ko-kod]')) return;
    e.preventDefault();
    var btn = e.target.closest('.btk-ko-rabat').querySelector('[data-btk-ko-zastosuj]');
    if (btn) btn.click();
  });

  function start() {
    var d = szuflada();
    if (!d) return;
    var czekaj;
    obserwator = new MutationObserver(function () {
      window.clearTimeout(czekaj);
      czekaj = window.setTimeout(function () { odswiez(true); }, 80);
    });
    odswiez(true);
    if (cfg.pokazTimer && !tykanie) tykanie = window.setInterval(tik, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batonik-produkt"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initProdukt(root) {
    if (!root || root.dataset.btkInit) return;
    root.dataset.btkInit = '1';

    /* Galeria: synchronizacja slajdów z miniaturami */
    var slajdy = root.querySelector('[data-btk-slajdy]');
    var miniatury = root.querySelectorAll('[data-btk-mini]');
    if (slajdy && miniatury.length) {
      var ustawAktywna = function (idx) {
        miniatury.forEach(function (m, i) {
          var on = i === idx;
          m.classList.toggle('is-aktywny', on);
          if (on && m.parentElement.scrollWidth > m.parentElement.clientWidth) {
            m.parentElement.scrollTo({ left: m.offsetLeft - m.parentElement.offsetLeft - 60, behavior: 'smooth' });
          }
        });
      };
      miniatury.forEach(function (m) {
        m.addEventListener('click', function () {
          var idx = parseInt(m.dataset.btkMini, 10) || 0;
          var slajd = slajdy.children[idx];
          if (slajd) slajdy.scrollTo({ left: slajd.offsetLeft - slajdy.offsetLeft, behavior: 'smooth' });
        });
      });
      var tick = null;
      slajdy.addEventListener('scroll', function () {
        if (tick) return;
        tick = window.requestAnimationFrame(function () {
          tick = null;
          var krok = slajdy.children[0] ? slajdy.children[0].offsetWidth + 20 : 1;
          ustawAktywna(Math.round(slajdy.scrollLeft / krok));
        });
      }, { passive: true });
    }

    /* Wideo: strzałki + odtwarzanie tylko w polu widzenia */
    var tor = root.querySelector('[data-btk-wideo-tor]');
    if (tor) {
      var prev = root.querySelector('[data-btk-wideo-prev]');
      var next = root.querySelector('[data-btk-wideo-next]');
      var odswiez = function () {
        var max = tor.scrollWidth - tor.clientWidth;
        if (prev) prev.hidden = tor.scrollLeft <= 4;
        if (next) next.hidden = max <= 4 || tor.scrollLeft >= max - 4;
      };
      var przesun = function (kier) {
        var karta = tor.children[0];
        tor.scrollBy({ left: kier * (karta ? karta.offsetWidth + 16 : 200), behavior: 'smooth' });
      };
      if (prev) prev.addEventListener('click', function () { przesun(-1); });
      if (next) next.addEventListener('click', function () { przesun(1); });
      tor.addEventListener('scroll', odswiez, { passive: true });
      window.addEventListener('resize', odswiez);
      odswiez();
    }
    var filmy = root.querySelectorAll('video[data-btk-autoplay]');
    if (filmy.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (wpisy) {
        wpisy.forEach(function (w) {
          if (w.isIntersecting) {
            var pr = w.target.play();
            if (pr && pr.catch) pr.catch(function () {});
          } else {
            w.target.pause();
          }
        });
      }, { threshold: 0.35 });
      filmy.forEach(function (f) { io.observe(f); });
    }
  }

  function start() {
    document.querySelectorAll('[data-btk-produkt]').forEach(initProdukt);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-btk-produkt]').forEach(initProdukt);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batonik-recenzje"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRec(root) {
    if (!root || root.dataset.btkInit) return;
    root.dataset.btkInit = '1';
    var btn = root.querySelector('[data-btk-rec-wiecej]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var krok = parseInt(btn.dataset.krok, 10) || 8;
      var ukryte = root.querySelectorAll('[data-btk-rec-karta].is-ukryta');
      for (var i = 0; i < ukryte.length && i < krok; i++) {
        ukryte[i].classList.remove('is-ukryta');
      }
      if (ukryte.length <= krok) btn.parentElement.hidden = true;
    });
  }
  function start() {
    document.querySelectorAll('[data-btk-rec]').forEach(initRec);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-btk-rec]').forEach(initRec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biodrowa-opinie"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(scope){
    (scope||document).querySelectorAll('[data-bio-op-more]').forEach(function(btn){
      if(btn.dataset.bioInit) return; btn.dataset.bioInit='1';
      var sec=btn.closest('.bio-op'); if(!sec) return;
      var step=parseInt(btn.getAttribute('data-step'),10)||3;
      btn.addEventListener('click',function(){
        var hidden=sec.querySelectorAll('.bio-op__item--extra[hidden]');
        for(var i=0;i<hidden.length && i<step;i++){ hidden[i].removeAttribute('hidden'); }
        if(sec.querySelectorAll('.bio-op__item--extra[hidden]').length===0){ btn.style.display='none'; }
      });
    });
  }
  if(document.readyState!=='loading'){ init(document); } else { document.addEventListener('DOMContentLoaded',function(){ init(document); }); }
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biodrowa-produkt"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initBio(scope){
  (scope||document).querySelectorAll('.bio-produkt').forEach(function(sec){
    if(sec.dataset.bioInit) return; sec.dataset.bioInit='1';

    /* ── Galeria ── */
    var main = sec.querySelector('[data-bio-main]');
    var thumbs = Array.prototype.slice.call(sec.querySelectorAll('[data-bio-thumb]'));
    var idx = 0;
    function activate(i){
      if(!thumbs.length || !main) return;
      if(i<0) i=thumbs.length-1; if(i>=thumbs.length) i=0;
      idx=i;
      var btn=thumbs[i], full=btn.getAttribute('data-full');
      if(full){ main.src=full; main.removeAttribute('srcset'); }
      thumbs.forEach(function(t){ t.classList.remove('is-active'); });
      btn.classList.add('is-active');
      btn.scrollIntoView({block:'nearest',inline:'nearest'});
    }
    thumbs.forEach(function(btn,i){ btn.addEventListener('click',function(){ activate(i); }); });
    var prev=sec.querySelector('[data-bio-prev]'), next=sec.querySelector('[data-bio-next]');
    if(prev) prev.addEventListener('click',function(){ activate(idx-1); });
    if(next) next.addEventListener('click',function(){ activate(idx+1); });

    /* ── Badge zamknięcie ── */
    var bx=sec.querySelector('[data-bio-badge-x]');
    if(bx) bx.addEventListener('click',function(){ var b=sec.querySelector('[data-bio-badge]'); if(b) b.style.display='none'; });

    /* ── Akcesoria: dodaj do koszyka + szuflada ── */
    sec.querySelectorAll('[data-bio-add]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var id=btn.getAttribute('data-variant-id'); if(!id) return;
        btn.disabled=true;
        var body={items:[{id:parseInt(id,10),quantity:1}],sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname};
        fetch((window.routes&&window.routes.cart_add_url?window.routes.cart_add_url:'/cart/add')+'.js',{
          method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)
        }).then(function(r){return r.json();}).then(function(data){
          btn.classList.add('is-done');
          try{
            var drawer=document.querySelector('cart-drawer');
            if(drawer && data.sections && data.sections['cart-drawer']){
              var doc=new DOMParser().parseFromString(data.sections['cart-drawer'],'text/html');
              var fresh=doc.querySelector('cart-drawer');
              if(fresh){ drawer.innerHTML=fresh.innerHTML; }
              drawer.classList.remove('is-empty');
            }
            var bubble=document.getElementById('cart-icon-bubble');
            if(bubble && data.sections && data.sections['cart-icon-bubble']){
              var d2=new DOMParser().parseFromString(data.sections['cart-icon-bubble'],'text/html');
              var fb=d2.querySelector('.shopify-section')||d2.body.firstElementChild;
              if(fb) bubble.innerHTML=fb.innerHTML;
            }
            if(drawer){
              if(typeof drawer.open==='function'){ drawer.open(); }
              else{ drawer.classList.add('active','animate','is-open'); document.body.classList.add('overflow-hidden'); }
            } else { document.dispatchEvent(new CustomEvent('cart:refresh')); }
          }catch(e){}
          setTimeout(function(){ btn.disabled=false; btn.classList.remove('is-done'); },2500);
        }).catch(function(){ btn.disabled=false; window.location.href=(window.routes&&window.routes.cart_url)||'/cart'; });
      });
    });
  });
  }
  if(document.readyState!=='loading'){ initBio(document); } else { document.addEventListener('DOMContentLoaded',function(){ initBio(document); }); }
  document.addEventListener('shopify:section:load',function(e){ initBio(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biodrowa-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    var bar=document.querySelector('[data-bio-sticky]'); if(!bar||bar.dataset.init) return; bar.dataset.init='1';
    var target=document.querySelector('.bio-produkt');
    var btn=bar.querySelector('[data-bio-sticky-btn]');
    if(btn){ btn.addEventListener('click',function(){
      var dest=document.querySelector('[data-bio-kaching]')||document.querySelector('.bio-produkt');
      if(dest){ dest.scrollIntoView({behavior:'smooth',block:'center'}); }
      else { window.scrollTo({top:0,behavior:'smooth'}); }
    }); }
    function toggle(show){ bar.classList.toggle('is-visible',show); }
    if('IntersectionObserver' in window && target){
      var seen=false;
      new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){ seen=true; toggle(false); }
          else if(seen){ toggle(true); }
        });
      },{threshold:0}).observe(target);
    } else {
      window.addEventListener('scroll',function(){ toggle(window.scrollY>600); },{passive:true});
    }
  }
  if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded',init); }
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["krzyzujace-koszyk"] && !Shopify.designMode) return;
  try {
    
(function () {
  var DOMYSLNE = {
    tytul: 'Mój koszyk',
    pokazLicznikSztuk: true,
    pokazTimer: true,
    timerMinuty: 10,
    timerTekst: 'Twój koszyk wygasa za',
    pokazDopasowanie: true,
    dopasowanieTekst: '',
    pokazZwrot: true,
    zwrotTekst: '30-dniowa gwarancja zwrotu pieniędzy',
    checkoutTekst: '',
    pokazPlatnosci: true
  };

  function konfiguracja() {
    var el = document.querySelector('[data-krz-koszyk-config]');
    if (!el) return DOMYSLNE;
    try {
      var wczytana = JSON.parse(el.textContent);
      var wynik = {};
      Object.keys(DOMYSLNE).forEach(function (k) {
        wynik[k] = wczytana[k] === undefined || wczytana[k] === '' ? DOMYSLNE[k] : wczytana[k];
      });
      return wynik;
    } catch (e) {
      return DOMYSLNE;
    }
  }

  /* ── Licznik czasu: wspólny dla całej sesji, nie restartuje się
        przy każdym otwarciu szuflady ── */
  var KLUCZ = 'krz-koszyk-koniec';

  function koniecOdliczania(minuty) {
    var teraz = Date.now();
    var zapis = 0;
    try { zapis = parseInt(window.sessionStorage.getItem(KLUCZ), 10) || 0; } catch (e) { zapis = 0; }
    if (!zapis || zapis <= teraz) {
      zapis = teraz + minuty * 60 * 1000;
      try { window.sessionStorage.setItem(KLUCZ, String(zapis)); } catch (e) {}
    }
    return zapis;
  }

  function sformatuj(ms) {
    var sek = Math.max(0, Math.floor(ms / 1000));
    var m = Math.floor(sek / 60);
    var s = sek % 60;
    return m + ':' + (s < 10 ? '0' + s : s);
  }

  var tykanie = null;

  function uruchomOdliczanie(cfg) {
    if (tykanie) window.clearInterval(tykanie);
    var koniec = koniecOdliczania(cfg.timerMinuty);

    function tik() {
      var pola = document.querySelectorAll('[data-krz-ko-zegar]');
      if (!pola.length) return;
      var zostalo = koniec - Date.now();
      var tekst = sformatuj(zostalo);
      pola.forEach(function (p) { p.textContent = tekst; });
      if (zostalo <= 0 && tykanie) window.clearInterval(tykanie);
    }

    tik();
    tykanie = window.setInterval(tik, 1000);
  }

  /* ── Dokładanie elementów, których motyw nie ma ── */
  function ubierz(cfg) {
    var szuflada = document.querySelector('cart-drawer');
    if (!szuflada) return;

    // 1. Tytuł + licznik sztuk
    var naglowek = szuflada.querySelector('.drawer__heading');
    if (naglowek) {
      if (cfg.tytul) {
        var etykieta = naglowek.querySelector('[data-krz-ko-tytul]');
        if (!etykieta) {
          naglowek.textContent = '';
          etykieta = document.createElement('span');
          etykieta.setAttribute('data-krz-ko-tytul', '');
          naglowek.appendChild(etykieta);
        }
        etykieta.textContent = cfg.tytul;
      }

      if (cfg.pokazLicznikSztuk) {
        var badge = naglowek.querySelector('.krz-ko-licznik');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'krz-ko-licznik';
          naglowek.appendChild(badge);
        }
        var pozycje = szuflada.querySelectorAll('#CartDrawer-CartItems .cart-item');
        var suma = 0;
        pozycje.forEach(function (w) {
          var pole = w.querySelector('input[name="updates[]"], .quantity__input');
          suma += pole ? (parseInt(pole.value, 10) || 0) : 1;
        });
        badge.textContent = String(suma);
      }
    }

    // Gdzie wstawiamy pasek i notę — nad listą pozycji
    var kotwica = szuflada.querySelector('.cart-drawer__body')
      || szuflada.querySelector('#CartDrawer-Form')
      || szuflada.querySelector('.drawer__inner');

    // 2. Pasek z licznikiem czasu
    if (cfg.pokazTimer && kotwica && !szuflada.querySelector('.krz-ko-pasek')) {
      var pasek = document.createElement('div');
      pasek.className = 'krz-ko-pasek';
      pasek.setAttribute('role', 'status');
      pasek.innerHTML = '';
      pasek.appendChild(document.createTextNode(cfg.timerTekst + ' '));
      var zegar = document.createElement('span');
      zegar.className = 'krz-ko-pasek__zegar';
      zegar.setAttribute('data-krz-ko-zegar', '');
      zegar.textContent = '--:--';
      pasek.appendChild(zegar);
      kotwica.insertBefore(pasek, kotwica.firstChild);
    }

    // 3. Nota o gwarancji dopasowania
    if (cfg.pokazDopasowanie && cfg.dopasowanieTekst && kotwica && !szuflada.querySelector('.krz-ko-nota')) {
      var nota = document.createElement('p');
      nota.className = 'krz-ko-nota';
      nota.textContent = cfg.dopasowanieTekst;
      var pasekIstniejacy = szuflada.querySelector('.krz-ko-pasek');
      if (pasekIstniejacy && pasekIstniejacy.parentNode === kotwica) {
        kotwica.insertBefore(nota, pasekIstniejacy.nextSibling);
      } else {
        kotwica.insertBefore(nota, kotwica.firstChild);
      }
    }

    // 4. Napis na przycisku płatności
    if (cfg.checkoutTekst) {
      var przycisk = szuflada.querySelector('#CartDrawer-Checkout');
      if (przycisk) {
        var napis = przycisk.querySelector('.button__label') || przycisk;
        if (napis.textContent.trim() !== cfg.checkoutTekst) {
          napis.textContent = cfg.checkoutTekst;
        }
      }
    }

    // 5. Linijka o gwarancji zwrotu — pod przyciskiem płatności
    if (cfg.pokazZwrot && cfg.zwrotTekst) {
      var stopka = szuflada.querySelector('.cart-drawer__footer');
      if (stopka && !stopka.querySelector('.krz-ko-zwrot')) {
        var linia = document.createElement('p');
        linia.className = 'krz-ko-zwrot';
        linia.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
          'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M12 2.8l7 3v5.4c0 4.3-2.9 8.3-7 9.6-4.1-1.3-7-5.3-7-9.6V5.8l7-3z"/>' +
          '<path d="M9 12l2.1 2.1L15.4 9.8"/></svg>';
        linia.appendChild(document.createTextNode(cfg.zwrotTekst));
        stopka.appendChild(linia);
      }
    }
  }

  // 6. Znaki platnosci — klonowane z <template> do stopki szuflady
  function dolozPlatnosci(cfg) {
    if (!cfg.pokazPlatnosci) return;
    var szablon = document.querySelector('[data-krz-koszyk-platnosci]');
    if (!szablon) return;
    var stopka = document.querySelector('cart-drawer .cart-drawer__footer');
    if (!stopka || stopka.querySelector('.krz-ko-platnosci')) return;
    stopka.appendChild(szablon.content.cloneNode(true));
  }

  function odswiez() {
    var cfg = konfiguracja();
    ubierz(cfg);
    dolozPlatnosci(cfg);
    if (cfg.pokazTimer) uruchomOdliczanie(cfg);
  }

  function start() {
    odswiez();

    // Shopify przerysowuje wnętrze szuflady po każdej zmianie koszyka —
    // obserwator dokłada nasze elementy z powrotem.
    var szuflada = document.querySelector('cart-drawer');
    if (!szuflada) return;

    var czekaj;
    var obserwator = new MutationObserver(function () {
      window.clearTimeout(czekaj);
      czekaj = window.setTimeout(odswiez, 60);
    });
    obserwator.observe(szuflada, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', odswiez);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["krzyzujace-opinie"] && !Shopify.designMode) return;
  try {
    
/*
  Karuzela opinii. Ta sama sygnatura co w sekcji „KRZ · Wideo opinie":
  obie inicjalizują elementy [data-krz-karuzela] i obie zabezpieczają się
  flagą data-krz-gotowa, więc podwójne uruchomienie nic nie psuje.
  Trzymamy własną kopię, żeby sekcja nie zależała od obecności innego pliku.
*/
(function () {
  function karuzela(root) {
    if (root.dataset.krzGotowa === '1') return;
    root.dataset.krzGotowa = '1';

    var tor = root.querySelector('[data-krz-tor]');
    if (!tor) return;

    var slajdy = Array.prototype.slice.call(tor.querySelectorAll('[data-krz-slajd]'));
    var kropki = Array.prototype.slice.call(root.querySelectorAll('[data-krz-kropka]'));
    var wstecz = root.querySelector('[data-krz-wstecz]');
    var dalej = root.querySelector('[data-krz-dalej]');
    var indeks = 0;

    function idz(i) {
      if (i < 0) i = 0;
      if (i > slajdy.length - 1) i = slajdy.length - 1;
      indeks = i;
      tor.scrollTo({ left: slajdy[i].offsetLeft - tor.offsetLeft, behavior: 'smooth' });
      odswiez();
    }

    function odswiez() {
      kropki.forEach(function (k, j) {
        var akt = j === indeks;
        k.classList.toggle('is-active', akt);
        k.setAttribute('aria-selected', akt ? 'true' : 'false');
      });
    }

    var czekaj;
    tor.addEventListener('scroll', function () {
      window.clearTimeout(czekaj);
      czekaj = window.setTimeout(function () {
        var lewa = tor.scrollLeft;
        var najblizszy = 0;
        var min = Infinity;
        slajdy.forEach(function (s, j) {
          var d = Math.abs(s.offsetLeft - tor.offsetLeft - lewa);
          if (d < min) { min = d; najblizszy = j; }
        });
        indeks = najblizszy;
        odswiez();
      }, 90);
    }, { passive: true });

    kropki.forEach(function (k) {
      k.addEventListener('click', function () { idz(parseInt(k.dataset.krzKropka, 10)); });
    });
    if (wstecz) wstecz.addEventListener('click', function () { idz(indeks - 1); });
    if (dalej) dalej.addEventListener('click', function () { idz(indeks + 1); });
  }

  function init() {
    document.querySelectorAll('[data-krz-karuzela]').forEach(karuzela);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["krzyzujace-pasek"] && !Shopify.designMode) return;
  try {
    
(function () {
  function uruchom(pasek) {
    if (pasek.dataset.krzGotowy === '1') return;
    pasek.dataset.krzGotowy = '1';

    var items = pasek.querySelectorAll('.krz-pasek__item');
    if (items.length < 2) return;

    var tempo = parseInt(pasek.dataset.tempo, 10) || 4;
    var i = 0;
    var timer = null;

    function nastepny() {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }

    function start() {
      stop();
      timer = setInterval(nastepny, tempo * 1000);
    }
    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    // Nie animuj, gdy karta jest w tle albo user prosi o mniej ruchu.
    var mniejRuchu = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mniejRuchu.matches) return;

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    start();
  }

  function init() {
    document.querySelectorAll('[data-krz-pasek]').forEach(uruchom);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme Editor: przeładowanie sekcji
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["krzyzujace-produkt"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* ══════════ GALERIA ══════════ */
  function galeria(root) {
    if (root.dataset.krzGotowa === '1') return;
    root.dataset.krzGotowa = '1';

    var tor = root.querySelector('[data-krz-tor]');
    if (!tor) return;

    var slajdy = Array.prototype.slice.call(tor.querySelectorAll('[data-krz-slajd]'));
    var miniatury = Array.prototype.slice.call(root.querySelectorAll('[data-krz-mini]'));
    var biezacyEl = root.querySelector('[data-krz-biezacy]');
    var wstecz = root.querySelector('[data-krz-wstecz]');
    var dalej = root.querySelector('[data-krz-dalej]');
    var indeks = 0;

    function idz(i) {
      if (i < 0) i = slajdy.length - 1;
      if (i >= slajdy.length) i = 0;
      indeks = i;
      tor.scrollTo({ left: slajdy[i].offsetLeft - tor.offsetLeft, behavior: 'smooth' });
      odswiez();
    }

    function odswiez() {
      if (biezacyEl) biezacyEl.textContent = String(indeks + 1);
      miniatury.forEach(function (m, j) {
        var akt = j === indeks;
        m.classList.toggle('is-active', akt);
        m.setAttribute('aria-selected', akt ? 'true' : 'false');
      });
    }

    // Śledzenie przewijania palcem — bez nasłuchu na każdą klatkę.
    var czekaj;
    tor.addEventListener('scroll', function () {
      window.clearTimeout(czekaj);
      czekaj = window.setTimeout(function () {
        var srodek = tor.scrollLeft + tor.clientWidth / 2;
        var najblizszy = 0;
        var min = Infinity;
        slajdy.forEach(function (s, j) {
          var d = Math.abs(s.offsetLeft - tor.offsetLeft + s.clientWidth / 2 - srodek);
          if (d < min) { min = d; najblizszy = j; }
        });
        indeks = najblizszy;
        odswiez();
      }, 90);
    }, { passive: true });

    miniatury.forEach(function (m) {
      m.addEventListener('click', function () { idz(parseInt(m.dataset.krzMini, 10)); });
    });
    if (wstecz) wstecz.addEventListener('click', function () { idz(indeks - 1); });
    if (dalej) dalej.addEventListener('click', function () { idz(indeks + 1); });

    /* ── Lightbox ── */
    var sekcja = root.closest('.krz-produkt');
    var lb = sekcja ? sekcja.querySelector('[data-krz-lightbox]') : null;
    if (!lb) return;

    var scena = lb.querySelector('[data-krz-lb-scena]');
    var lbBiez = lb.querySelector('[data-krz-lb-biezacy]');
    var lbIndeks = 0;
    var ostatnioAktywny = null;

    var zrodla = slajdy.map(function (s) {
      var img = s.querySelector('img');
      return img ? { src: img.currentSrc || img.src, alt: img.alt || '' } : null;
    });

    function pokaz(i) {
      if (i < 0) i = zrodla.length - 1;
      if (i >= zrodla.length) i = 0;
      lbIndeks = i;
      var z = zrodla[i];
      scena.innerHTML = '';
      if (z) {
        var img = document.createElement('img');
        img.src = z.src;
        img.alt = z.alt;
        scena.appendChild(img);
      }
      if (lbBiez) lbBiez.textContent = String(i + 1);
    }

    function otworz(i) {
      ostatnioAktywny = document.activeElement;
      pokaz(i);
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
      var zamknijBtn = lb.querySelector('[data-krz-lb-zamknij]');
      if (zamknijBtn) zamknijBtn.focus();
    }

    function zamknij() {
      lb.hidden = true;
      document.body.style.overflow = '';
      if (ostatnioAktywny && ostatnioAktywny.focus) ostatnioAktywny.focus();
    }

    slajdy.forEach(function (s, j) {
      s.addEventListener('click', function () { otworz(j); });
    });

    var btnZamknij = lb.querySelector('[data-krz-lb-zamknij]');
    var btnW = lb.querySelector('[data-krz-lb-wstecz]');
    var btnD = lb.querySelector('[data-krz-lb-dalej]');
    if (btnZamknij) btnZamknij.addEventListener('click', zamknij);
    if (btnW) btnW.addEventListener('click', function () { pokaz(lbIndeks - 1); });
    if (btnD) btnD.addEventListener('click', function () { pokaz(lbIndeks + 1); });

    lb.addEventListener('click', function (e) {
      if (e.target === lb) zamknij();
    });

    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') zamknij();
      if (e.key === 'ArrowLeft') pokaz(lbIndeks - 1);
      if (e.key === 'ArrowRight') pokaz(lbIndeks + 1);
    });
  }

  /* ══════════ LICZNIK CZASU ══════════ */
  function timer(el) {
    if (el.dataset.krzGotowy === '1') return;
    el.dataset.krzGotowy = '1';

    var minuty = parseInt(el.dataset.minuty, 10) || 30;
    var klucz = el.dataset.klucz || 'krz-timer';
    var koniec;

    try {
      var zapis = window.sessionStorage.getItem(klucz);
      koniec = zapis ? parseInt(zapis, 10) : 0;
    } catch (e) {
      koniec = 0;
    }

    var teraz = Date.now();
    if (!koniec || koniec <= teraz) {
      koniec = teraz + minuty * 60 * 1000;
      try { window.sessionStorage.setItem(klucz, String(koniec)); } catch (e) {}
    }

    var hEl = el.querySelector('[data-krz-h]');
    var mEl = el.querySelector('[data-krz-m]');
    var sEl = el.querySelector('[data-krz-s]');

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var zostalo = Math.max(0, koniec - Date.now());
      var sek = Math.floor(zostalo / 1000);
      if (hEl) hEl.textContent = pad(Math.floor(sek / 3600));
      if (mEl) mEl.textContent = pad(Math.floor((sek % 3600) / 60));
      if (sEl) sEl.textContent = pad(sek % 60);
      if (zostalo <= 0) window.clearInterval(uchwyt);
    }

    tick();
    var uchwyt = window.setInterval(tick, 1000);
  }

  /* ══════════ TRIGGER PRZEWODNIKA ROZMIARÓW ══════════ */
  function rozmiary() {
    document.querySelectorAll('[data-krz-otworz-rozmiary]').forEach(function (btn) {
      if (btn.dataset.krzGotowy === '1') return;
      btn.dataset.krzGotowy = '1';
      btn.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('krz:otworz-rozmiary'));
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-krz-galeria]').forEach(galeria);
    document.querySelectorAll('[data-krz-timer]').forEach(timer);
    rozmiary();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["krzyzujace-recenzje"] && !Shopify.designMode) return;
  try {
    
(function () {
  function recenzje(root) {
    if (root.dataset.krzGotowe === '1') return;
    root.dataset.krzGotowe = '1';

    var lista = root.querySelector('[data-krz-lista]');
    if (!lista) return;

    var itemy = Array.prototype.slice.call(lista.querySelectorAll('.krz-rec__item'));
    var sortSelect = root.querySelector('[data-krz-sort]');
    var wiecejBtn = root.querySelector('[data-krz-wiecej]');
    var naStrone = parseInt(root.dataset.naStrone, 10) || 6;
    var widoczne = naStrone;

    function liczba(el, klucz) {
      return parseFloat(el.dataset[klucz]) || 0;
    }

    function przerysuj() {
      itemy.forEach(function (el, j) {
        el.hidden = j >= widoczne;
      });
      if (wiecejBtn) {
        wiecejBtn.hidden = widoczne >= itemy.length;
      }
    }

    function sortuj(tryb) {
      var kopia = itemy.slice();
      kopia.sort(function (a, b) {
        if (tryb === 'zdjecia') {
          var rozn = liczba(b, 'zdjecie') - liczba(a, 'zdjecie');
          if (rozn !== 0) return rozn;
          return liczba(a, 'kolejnosc') - liczba(b, 'kolejnosc');
        }
        if (tryb === 'najwyzsze') return liczba(b, 'ocena') - liczba(a, 'ocena');
        if (tryb === 'najnizsze') return liczba(a, 'ocena') - liczba(b, 'ocena');
        return liczba(a, 'kolejnosc') - liczba(b, 'kolejnosc');
      });
      kopia.forEach(function (el) { lista.appendChild(el); });
      itemy = kopia;
      widoczne = naStrone;
      przerysuj();
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () { sortuj(sortSelect.value); });
    }
    if (wiecejBtn) {
      wiecejBtn.addEventListener('click', function () {
        widoczne += naStrone;
        przerysuj();
      });
    }

    przerysuj();
  }

  function init() {
    document.querySelectorAll('[data-krz-recenzje]').forEach(recenzje);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["krzyzujace-rozmiary"] && !Shopify.designMode) return;
  try {
    
(function () {
  function przewodnik(root) {
    if (root.dataset.krzGotowy === '1') return;
    root.dataset.krzGotowy = '1';

    var okno = root.querySelector('.krz-rozm__okno');
    var daneEl = root.querySelector('[data-krz-dane]');
    var rozmiary = [];
    try { rozmiary = JSON.parse(daneEl.textContent); } catch (e) { rozmiary = []; }

    var trzymanie = 'zrownowazone';
    var ostatnioAktywny = null;

    /* ── Otwieranie / zamykanie ── */
    function otworz() {
      ostatnioAktywny = document.activeElement;
      root.hidden = false;
      document.body.style.overflow = 'hidden';
      var x = root.querySelector('[data-krz-zamknij]');
      if (x) x.focus();
    }
    function zamknij() {
      root.hidden = true;
      document.body.style.overflow = '';
      if (ostatnioAktywny && ostatnioAktywny.focus) ostatnioAktywny.focus();
    }

    document.addEventListener('krz:otworz-rozmiary', otworz);
    root.querySelectorAll('[data-krz-zamknij]').forEach(function (b) {
      b.addEventListener('click', zamknij);
    });
    var zaslona = root.querySelector('[data-krz-zaslona]');
    if (zaslona) zaslona.addEventListener('click', zamknij);
    document.addEventListener('keydown', function (e) {
      if (!root.hidden && e.key === 'Escape') zamknij();
    });

    /* ── Zakładki ── */
    var zakladki = Array.prototype.slice.call(root.querySelectorAll('[data-krz-tab]'));
    var panele = Array.prototype.slice.call(root.querySelectorAll('[data-krz-panel]'));
    zakladki.forEach(function (z) {
      z.addEventListener('click', function () {
        zakladki.forEach(function (i) {
          var akt = i === z;
          i.classList.toggle('is-active', akt);
          i.setAttribute('aria-selected', akt ? 'true' : 'false');
        });
        panele.forEach(function (p) {
          p.classList.toggle('is-active', p.dataset.krzPanel === z.dataset.krzTab);
        });
      });
    });

    /* ── Kroki kreatora ── */
    var kroki = Array.prototype.slice.call(root.querySelectorAll('[data-krz-krok]'));
    var postep = root.querySelector('[data-krz-postep]');

    function pokazKrok(nr) {
      kroki.forEach(function (k) {
        k.classList.toggle('is-active', k.dataset.krzKrok === String(nr));
      });
      if (postep) postep.style.width = (nr / kroki.length) * 100 + '%';
      if (okno) okno.scrollTop = 0;
    }

    var wzrostEl = root.querySelector('[data-krz-wzrost]');
    var wagaEl = root.querySelector('[data-krz-waga]');
    var bladEl = root.querySelector('[data-krz-blad]');

    root.querySelectorAll('[data-krz-dalej]').forEach(function (b) {
      b.addEventListener('click', function () {
        var cel = parseInt(b.dataset.krzDalej, 10);

        if (cel === 2) {
          var w = parseFloat(wzrostEl && wzrostEl.value);
          var kg = parseFloat(wagaEl && wagaEl.value);
          if (!w || !kg || w < 130 || w > 210 || kg < 35 || kg > 200) {
            if (bladEl) bladEl.hidden = false;
            return;
          }
          if (bladEl) bladEl.hidden = true;
        }

        if (cel === 3) policz();
        pokazKrok(cel);
      });
    });

    root.querySelectorAll('[data-krz-wstecz]').forEach(function (b) {
      b.addEventListener('click', function () {
        pokazKrok(parseInt(b.dataset.krzWstecz, 10));
      });
    });

    var restart = root.querySelector('[data-krz-restart]');
    if (restart) {
      restart.addEventListener('click', function () {
        if (wzrostEl) wzrostEl.value = '';
        if (wagaEl) wagaEl.value = '';
        trzymanie = 'zrownowazone';
        root.querySelectorAll('[data-krz-trzymanie]').forEach(function (k, j) {
          k.classList.toggle('is-wybrana', j === 0);
        });
        pokazKrok(1);
      });
    }

    /* ── Wybór trzymania ── */
    var kartyT = Array.prototype.slice.call(root.querySelectorAll('[data-krz-trzymanie]'));
    kartyT.forEach(function (k) {
      k.addEventListener('click', function () {
        trzymanie = k.dataset.krzTrzymanie;
        kartyT.forEach(function (i) { i.classList.toggle('is-wybrana', i === k); });
      });
    });

    /* ── Dobór rozmiaru ── */
    function policz() {
      var w = parseFloat(wzrostEl && wzrostEl.value);
      var kg = parseFloat(wagaEl && wagaEl.value);
      if (!w || !kg || !rozmiary.length) return;

      var bmi = kg / Math.pow(w / 100, 2);

      var idx = -1;
      for (var i = 0; i < rozmiary.length; i++) {
        if (bmi >= rozmiary[i].bmiOd && bmi <= rozmiary[i].bmiDo) { idx = i; break; }
      }
      // Poza zakresem tabeli: pierwszy albo ostatni wiersz.
      if (idx === -1) idx = bmi < rozmiary[0].bmiOd ? 0 : rozmiary.length - 1;

      // Mocniejsze trzymanie = jeden rozmiar niżej, o ile jest z czego schodzić.
      if (trzymanie === 'wzmocnione' && idx > 0) idx = idx - 1;

      var r = rozmiary[idx];
      var ustaw = function (sel, val) {
        var el = root.querySelector(sel);
        if (el) el.textContent = val;
      };
      ustaw('[data-krz-wynik]', r.rozmiar);
      ustaw('[data-krz-wynik-pl]', r.pl ? 'Rozmiar PL: ' + r.pl : '');
      ustaw('[data-krz-talia]', r.talia || '—');
      ustaw('[data-krz-biodra]', r.biodra || '—');
      ustaw('[data-krz-bmi]', bmi.toFixed(1).replace('.', ','));
    }
  }

  function init() {
    document.querySelectorAll('[data-krz-rozmiary]').forEach(przewodnik);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["krzyzujace-wideo"] && !Shopify.designMode) return;
  try {
    
(function () {
  function karuzela(root) {
    if (root.dataset.krzGotowa === '1') return;
    root.dataset.krzGotowa = '1';

    var tor = root.querySelector('[data-krz-tor]');
    if (!tor) return;

    var slajdy = Array.prototype.slice.call(tor.querySelectorAll('[data-krz-slajd]'));
    var kropki = Array.prototype.slice.call(root.querySelectorAll('[data-krz-kropka]'));
    var wstecz = root.querySelector('[data-krz-wstecz]');
    var dalej = root.querySelector('[data-krz-dalej]');
    var indeks = 0;

    function idz(i) {
      if (i < 0) i = 0;
      if (i > slajdy.length - 1) i = slajdy.length - 1;
      indeks = i;
      tor.scrollTo({ left: slajdy[i].offsetLeft - tor.offsetLeft, behavior: 'smooth' });
      odswiez();
    }

    function odswiez() {
      kropki.forEach(function (k, j) {
        var akt = j === indeks;
        k.classList.toggle('is-active', akt);
        k.setAttribute('aria-selected', akt ? 'true' : 'false');
      });
    }

    var czekaj;
    tor.addEventListener('scroll', function () {
      window.clearTimeout(czekaj);
      czekaj = window.setTimeout(function () {
        var lewa = tor.scrollLeft;
        var najblizszy = 0;
        var min = Infinity;
        slajdy.forEach(function (s, j) {
          var d = Math.abs(s.offsetLeft - tor.offsetLeft - lewa);
          if (d < min) { min = d; najblizszy = j; }
        });
        indeks = najblizszy;
        odswiez();
      }, 90);
    }, { passive: true });

    kropki.forEach(function (k) {
      k.addEventListener('click', function () { idz(parseInt(k.dataset.krzKropka, 10)); });
    });
    if (wstecz) wstecz.addEventListener('click', function () { idz(indeks - 1); });
    if (dalej) dalej.addEventListener('click', function () { idz(indeks + 1); });
  }

  function init() {
    document.querySelectorAll('[data-krz-karuzela]').forEach(karuzela);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maska-artykul"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__mskKar) return;
  window.__mskKar = true;
  function step(track) { var c = track.querySelector('*'); return c ? c.getBoundingClientRect().width + 16 : track.clientWidth * 0.85; }
  function bind() {
    document.querySelectorAll('[data-msk-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-msk-track]');
      if (!track || wrap.dataset.mskBound === '1') return;
      wrap.dataset.mskBound = '1';
      var prev = wrap.querySelector('[data-msk-prev]'), next = wrap.querySelector('[data-msk-next]'), bar = wrap.querySelector('[data-msk-bar]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(track), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(track), behavior: 'smooth' }); });
      if (bar) track.addEventListener('scroll', function () { var max = track.scrollWidth - track.clientWidth; bar.style.setProperty('--msk-p', max > 0 ? (track.scrollLeft / max) : 0); });
    });
  }
  if (document.readyState !== 'loading') bind(); else document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
})();

(function () {
  function initArt(root) {
    if (!root || root.dataset.mskArtGotowe === '1') return;
    root.dataset.mskArtGotowe = '1';
    // Miniatury karty produktu
    root.querySelectorAll('[data-msk-kp]').forEach(function (kp) {
      var main = kp.querySelector('[data-msk-kp-main]');
      var minis = kp.querySelectorAll('[data-msk-kp-mini]');
      minis.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.getAttribute('data-msk-kp-mini');
          if (main && src) main.setAttribute('src', src);
          minis.forEach(function (m) { m.classList.remove('is-aktywny'); });
          btn.classList.add('is-aktywny');
        });
      });
    });
    // FAQ: pojedyncze otwarcie w obrębie jednej listy
    root.querySelectorAll('.maska-art__faq-lista').forEach(function (lista) {
      var items = lista.querySelectorAll('details');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () { if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; }); });
      });
    });
  }
  document.querySelectorAll('[data-msk-artykul]').forEach(initArt);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-msk-artykul]');
    if (el) initArt(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maska-efekty"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__mskKar) return;
  window.__mskKar = true;
  function step(track) { var c = track.querySelector('*'); return c ? c.getBoundingClientRect().width + 16 : track.clientWidth * 0.85; }
  function bind() {
    document.querySelectorAll('[data-msk-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-msk-track]');
      if (!track || wrap.dataset.mskBound === '1') return;
      wrap.dataset.mskBound = '1';
      var prev = wrap.querySelector('[data-msk-prev]'), next = wrap.querySelector('[data-msk-next]'), bar = wrap.querySelector('[data-msk-bar]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(track), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(track), behavior: 'smooth' }); });
      if (bar) track.addEventListener('scroll', function () { var max = track.scrollWidth - track.clientWidth; bar.style.setProperty('--msk-p', max > 0 ? (track.scrollLeft / max) : 0); });
    });
  }
  if (document.readyState !== 'loading') bind(); else document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maska-obraz-tekst"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.mskGotowe === '1') return;
    root.dataset.mskGotowe = '1';
    var akord = root.querySelector('[data-msk-akord]');
    if (akord) {
      var items = akord.querySelectorAll('details');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    }
  }
  document.querySelectorAll('[data-msk-ot]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-msk-ot]');
    if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maska-opinie"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__mskKar) return;
  window.__mskKar = true;
  function step(track) { var c = track.querySelector('*'); return c ? c.getBoundingClientRect().width + 16 : track.clientWidth * 0.85; }
  function bind() {
    document.querySelectorAll('[data-msk-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-msk-track]');
      if (!track || wrap.dataset.mskBound === '1') return;
      wrap.dataset.mskBound = '1';
      var prev = wrap.querySelector('[data-msk-prev]'), next = wrap.querySelector('[data-msk-next]'), bar = wrap.querySelector('[data-msk-bar]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(track), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(track), behavior: 'smooth' }); });
      if (bar) track.addEventListener('scroll', function () { var max = track.scrollWidth - track.clientWidth; bar.style.setProperty('--msk-p', max > 0 ? (track.scrollLeft / max) : 0); });
    });
  }
  if (document.readyState !== 'loading') bind(); else document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maska-pakiety"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__mskKar) return;
  window.__mskKar = true;
  function step(track) { var c = track.querySelector('*'); return c ? c.getBoundingClientRect().width + 16 : track.clientWidth * 0.85; }
  function bind() {
    document.querySelectorAll('[data-msk-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-msk-track]');
      if (!track || wrap.dataset.mskBound === '1') return;
      wrap.dataset.mskBound = '1';
      var prev = wrap.querySelector('[data-msk-prev]'), next = wrap.querySelector('[data-msk-next]'), bar = wrap.querySelector('[data-msk-bar]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(track), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(track), behavior: 'smooth' }); });
      if (bar) track.addEventListener('scroll', function () { var max = track.scrollWidth - track.clientWidth; bar.style.setProperty('--msk-p', max > 0 ? (track.scrollLeft / max) : 0); });
    });
  }
  if (document.readyState !== 'loading') bind(); else document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maska-pasek"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.mskGotowe === '1') return;
    root.dataset.mskGotowe = '1';
    var msgs = Array.prototype.slice.call(root.querySelectorAll('[data-msk-pasek-msg]'));
    if (msgs.length < 2) return;
    var i = 0, timer = null;
    var auto = root.getAttribute('data-auto') === 'true';
    var czas = (parseInt(root.getAttribute('data-czas'), 10) || 4) * 1000;
    function show(n) {
      msgs[i].classList.remove('is-aktywny');
      i = (n + msgs.length) % msgs.length;
      msgs[i].classList.add('is-aktywny');
    }
    function start() { if (auto) { stop(); timer = setInterval(function () { show(i + 1); }, czas); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    var prev = root.querySelector('[data-msk-pasek-prev]');
    var next = root.querySelector('[data-msk-pasek-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
    if (next) next.addEventListener('click', function () { show(i + 1); start(); });
    start();
  }
  document.querySelectorAll('[data-msk-pasek]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-msk-pasek]');
    if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maska-produkt"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.mskGotowe === '1') return;
    root.dataset.mskGotowe = '1';

    // Galeria: podmiana zdjęcia głównego po kliknięciu miniatury
    var main = root.querySelector('[data-msk-main]');
    var minis = root.querySelectorAll('[data-msk-mini]');
    minis.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-msk-mini');
        if (main && src) main.setAttribute('src', src);
        minis.forEach(function (m) { m.classList.remove('is-aktywny'); });
        btn.classList.add('is-aktywny');
      });
    });

    // Akordeony: pojedyncze otwarcie (opcjonalnie zamykaj pozostałe)
    var akord = root.querySelector('[data-msk-akord]');
    if (akord) {
      var items = akord.querySelectorAll('details');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) {
            items.forEach(function (o) { if (o !== d) o.open = false; });
          }
        });
      });
    }
  }

  document.querySelectorAll('[data-msk-produkt]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-msk-produkt]');
    if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maska-recenzje"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.mskGotowe === '1') return;
    root.dataset.mskGotowe = '1';
    var lista = root.querySelector('[data-msk-rec-lista]');
    var brak = root.querySelector('[data-msk-rec-brak]');
    var selStar = root.querySelector('[data-msk-flt-star]');
    var fltFoto = root.querySelector('[data-msk-flt-foto]');
    if (!lista) return;
    var items = Array.prototype.slice.call(lista.querySelectorAll('.maska-recenzje__item'));
    function apply() {
      var minStar = selStar ? parseInt(selStar.value, 10) : 0;
      var tylkoFoto = fltFoto ? fltFoto.checked : false;
      var widoczne = 0;
      items.forEach(function (it) {
        var s = parseInt(it.getAttribute('data-stars'), 10) || 0;
        var f = it.getAttribute('data-foto') === '1';
        var ok = (minStar === 0 || s >= minStar) && (!tylkoFoto || f);
        it.style.display = ok ? '' : 'none';
        if (ok) widoczne++;
      });
      if (brak) brak.hidden = widoczne !== 0;
    }
    if (selStar) selStar.addEventListener('change', apply);
    if (fltFoto) fltFoto.addEventListener('change', apply);
  }
  document.querySelectorAll('[data-msk-recenzje]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-msk-recenzje]');
    if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maska-statystyki"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__mskKar) return;
  window.__mskKar = true;
  function step(track) { var c = track.querySelector('*'); return c ? c.getBoundingClientRect().width + 16 : track.clientWidth * 0.85; }
  function bind() {
    document.querySelectorAll('[data-msk-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-msk-track]');
      if (!track || wrap.dataset.mskBound === '1') return;
      wrap.dataset.mskBound = '1';
      var prev = wrap.querySelector('[data-msk-prev]'), next = wrap.querySelector('[data-msk-next]'), bar = wrap.querySelector('[data-msk-bar]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(track), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(track), behavior: 'smooth' }); });
      if (bar) track.addEventListener('scroll', function () { var max = track.scrollWidth - track.clientWidth; bar.style.setProperty('--msk-p', max > 0 ? (track.scrollLeft / max) : 0); });
    });
  }
  if (document.readyState !== 'loading') bind(); else document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maska-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(bar) {
    if (!bar || bar.dataset.mskGotowe === '1') return;
    bar.dataset.mskGotowe = '1';
    var prog = parseInt(bar.getAttribute('data-prog'), 10) || 500;
    function onScroll() {
      if (window.scrollY > prog) bar.classList.add('is-widoczny');
      else bar.classList.remove('is-widoczny');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var cta = bar.querySelector('[data-msk-sticky-cta]');
    if (cta) cta.addEventListener('click', function () {
      var cel = document.querySelector('[data-msk-kaching]') || document.querySelector('[data-msk-produkt]');
      if (cel) cel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
  document.querySelectorAll('[data-msk-sticky]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-msk-sticky]');
    if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maska-ugc"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__mskKar) return;
  window.__mskKar = true;
  function step(track) { var c = track.querySelector('*'); return c ? c.getBoundingClientRect().width + 16 : track.clientWidth * 0.85; }
  function bind() {
    document.querySelectorAll('[data-msk-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-msk-track]');
      if (!track || wrap.dataset.mskBound === '1') return;
      wrap.dataset.mskBound = '1';
      var prev = wrap.querySelector('[data-msk-prev]'), next = wrap.querySelector('[data-msk-next]'), bar = wrap.querySelector('[data-msk-bar]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(track), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(track), behavior: 'smooth' }); });
      if (bar) track.addEventListener('scroll', function () { var max = track.scrollWidth - track.clientWidth; bar.style.setProperty('--msk-p', max > 0 ? (track.scrollLeft / max) : 0); });
    });
  }
  if (document.readyState !== 'loading') bind(); else document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
})();

(function () {
  function initUgc(root) {
    if (!root || root.dataset.mskUgcGotowe === '1') return;
    root.dataset.mskUgcGotowe = '1';
    var modal = root.querySelector('[data-msk-ugc-modal]');
    var stage = root.querySelector('[data-msk-ugc-stage]');
    if (!modal || !stage) return;
    function close() {
      modal.setAttribute('hidden', '');
      stage.innerHTML = '';
      document.body.style.overflow = '';
    }
    function open(i) {
      var src = root.querySelector('[data-msk-ugc-src="' + i + '"]');
      if (!src) return;
      stage.innerHTML = src.innerHTML;
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      var v = stage.querySelector('video');
      if (v) { try { v.play(); } catch (e) {} }
    }
    root.querySelectorAll('[data-msk-ugc-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { open(btn.getAttribute('data-msk-ugc-open')); });
    });
    root.querySelectorAll('[data-msk-ugc-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }
  document.querySelectorAll('[data-msk-ugc]').forEach(initUgc);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-msk-ugc]');
    if (el) initUgc(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maska-uzupelniajace"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__mskKar) return;
  window.__mskKar = true;
  function step(track) { var c = track.querySelector('*'); return c ? c.getBoundingClientRect().width + 16 : track.clientWidth * 0.85; }
  function bind() {
    document.querySelectorAll('[data-msk-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-msk-track]');
      if (!track || wrap.dataset.mskBound === '1') return;
      wrap.dataset.mskBound = '1';
      var prev = wrap.querySelector('[data-msk-prev]'), next = wrap.querySelector('[data-msk-next]'), bar = wrap.querySelector('[data-msk-bar]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(track), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(track), behavior: 'smooth' }); });
      if (bar) track.addEventListener('scroll', function () { var max = track.scrollWidth - track.clientWidth; bar.style.setProperty('--msk-p', max > 0 ? (track.scrollLeft / max) : 0); });
    });
  }
  if (document.readyState !== 'loading') bind(); else document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poporodowe-licznik"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.ppGotowe === '1') return;
    root.dataset.ppGotowe = '1';

    var godziny = parseFloat(root.dataset.godziny) || 12;
    var okres = godziny * 60 * 60 * 1000;
    var klucz = root.dataset.klucz || 'pp-licznik';

    var elH = root.querySelector('[data-pp-h]');
    var elM = root.querySelector('[data-pp-m]');
    var elS = root.querySelector('[data-pp-s]');
    if (!elH || !elM || !elS) return;

    function pobierzKoniec() {
      var zapis = null;
      try {
        zapis = window.localStorage.getItem(klucz);
      } catch (e) {
        zapis = null;
      }

      var koniec = zapis ? parseInt(zapis, 10) : NaN;
      if (!koniec || isNaN(koniec) || koniec <= Date.now()) {
        koniec = Date.now() + okres;
        try {
          window.localStorage.setItem(klucz, String(koniec));
        } catch (e) {
          /* tryb prywatny — licznik nadal działa, po prostu bez zapamiętania */
        }
      }
      return koniec;
    }

    var koniec = pobierzKoniec();

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function tik() {
      var zostalo = koniec - Date.now();
      if (zostalo <= 0) {
        koniec = pobierzKoniec();
        zostalo = koniec - Date.now();
      }
      var sek = Math.floor(zostalo / 1000);
      elH.textContent = pad(Math.floor(sek / 3600));
      elM.textContent = pad(Math.floor((sek % 3600) / 60));
      elS.textContent = pad(sek % 60);
    }

    tik();
    setInterval(tik, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-pp-licznik]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poporodowe-produkt"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.ppGotowe === '1') return;
    root.dataset.ppGotowe = '1';

    /* ── Galeria: miniatury przełączają główne zdjęcie ── */
    var galeria = root.querySelector('[data-pp-galeria]');
    if (galeria) {
      var slajdy = galeria.querySelectorAll('[data-pp-slajd]');
      var miniatury = galeria.querySelectorAll('[data-pp-miniatura]');

      miniatury.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var idx = mini.getAttribute('data-pp-miniatura');
          slajdy.forEach(function (s) {
            s.classList.toggle('is-aktywny', s.getAttribute('data-pp-slajd') === idx);
          });
          miniatury.forEach(function (m) {
            m.classList.toggle('is-aktywny', m === mini);
          });
        });
      });
    }

    /* ── Powiększenie zdjęcia ── */
    var modalZdjecie = root.querySelector('[data-pp-modal-zdjecie]');
    var przyciskZoom = root.querySelector('[data-pp-zoom]');
    if (modalZdjecie && przyciskZoom) {
      przyciskZoom.addEventListener('click', function () {
        var aktywny = root.querySelector('.pp-galeria__slajd.is-aktywny img');
        var duze = modalZdjecie.querySelector('[data-pp-zdjecie-duze]');
        if (aktywny && duze) {
          duze.src = aktywny.currentSrc || aktywny.src;
          duze.alt = aktywny.alt || '';
        }
        if (typeof modalZdjecie.showModal === 'function') modalZdjecie.showModal();
      });
    }

    /* ── Przewodnik po rozmiarach ── */
    var modalRozmiary = root.querySelector('[data-pp-modal-rozmiary]');
    var otworzRozmiary = root.querySelector('[data-pp-otworz-rozmiary]');
    if (modalRozmiary && otworzRozmiary) {
      otworzRozmiary.addEventListener('click', function () {
        if (typeof modalRozmiary.showModal === 'function') modalRozmiary.showModal();
      });
    }

    /* ── Zamykanie modali ── */
    root.querySelectorAll('[data-pp-zamknij]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dlg = btn.closest('dialog');
        if (dlg) dlg.close();
      });
    });
    root.querySelectorAll('.pp-modal').forEach(function (dlg) {
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) dlg.close();
      });
    });

    /* ── Wariant: select (bez name) → ukryte pole wysyłane w formularzu ── */
    var selectWariant = root.querySelector('[data-pp-wariant]');
    var inputWariant = root.querySelector('[data-pp-wariant-input]');
    if (selectWariant && inputWariant) {
      selectWariant.addEventListener('change', function () {
        inputWariant.value = selectWariant.value;
        var opcja = selectWariant.options[selectWariant.selectedIndex];
        var cena = root.querySelector('.pp-natywny__cena-aktualna');
        if (cena && opcja && opcja.dataset.cena) cena.textContent = opcja.dataset.cena;
      });
    }

    /* ── FAQ ── */
    var faq = root.querySelector('[data-pp-faq]');
    if (faq) {
      faq.querySelectorAll('.pp-faq__pytanie').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var otwarte = btn.getAttribute('aria-expanded') === 'true';
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          btn.setAttribute('aria-expanded', otwarte ? 'false' : 'true');
          if (panel) panel.hidden = otwarte;
        });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-pp-produkt]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poporodowe-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(pasek) {
    if (pasek.dataset.ppGotowe === '1') return;
    pasek.dataset.ppGotowe = '1';

    pasek.hidden = false;

    var prog = parseInt(pasek.dataset.prog, 10) || 600;
    var glownyAtc = document.querySelector('[data-pp-atc]');

    function pokaz(czy) {
      pasek.classList.toggle('is-widoczny', czy);
    }

    if (glownyAtc && 'IntersectionObserver' in window) {
      /* Pasek pojawia się, gdy główny przycisk zniknie z ekranu ku górze */
      var obs = new IntersectionObserver(function (wpisy) {
        wpisy.forEach(function (wpis) {
          var ponizej = wpis.boundingClientRect.top > 0;
          pokaz(!wpis.isIntersecting && !ponizej);
        });
      }, { rootMargin: '0px', threshold: 0 });
      obs.observe(glownyAtc);
    } else {
      window.addEventListener('scroll', function () {
        pokaz(window.scrollY > prog);
      }, { passive: true });
    }

    /* Wariant: select (bez name) → ukryte pole + cena w pasku */
    var select = pasek.querySelector('[data-pp-sticky-wariant]');
    var input = pasek.querySelector('[data-pp-sticky-wariant-input]');
    var cena = pasek.querySelector('[data-pp-sticky-cena]');
    if (select) {
      select.addEventListener('change', function () {
        if (input) input.value = select.value;
        var opcja = select.options[select.selectedIndex];
        if (cena && opcja && opcja.dataset.cena) cena.textContent = opcja.dataset.cena;
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-pp-sticky]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poporodowe-ticker"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.ppGotowe === '1') return;
    root.dataset.ppGotowe = '1';

    var itemy = root.querySelectorAll('[data-pp-ticker-item]');
    if (itemy.length < 2) return;

    var tempo = parseInt(root.dataset.tempo, 10) || 3500;
    var i = 0;

    setInterval(function () {
      itemy[i].classList.remove('is-aktywny');
      i = (i + 1) % itemy.length;
      itemy[i].classList.add('is-aktywny');
    }, tempo);
  }

  function initAll() {
    document.querySelectorAll('[data-pp-ticker]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poporodowe-ugc"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.ppGotowe === '1') return;
    root.dataset.ppGotowe = '1';

    var tor = root.querySelector('[data-pp-ugc-tor]');
    if (!tor) return;

    function przesun(kierunek) {
      var kafel = tor.querySelector('.pp-ugc__item');
      var krok = kafel ? kafel.getBoundingClientRect().width + 12 : 300;
      tor.scrollBy({ left: kierunek * krok, behavior: 'smooth' });
    }

    var lewo = root.querySelector('[data-pp-ugc-lewo]');
    var prawo = root.querySelector('[data-pp-ugc-prawo]');
    if (lewo) lewo.addEventListener('click', function () { przesun(-1); });
    if (prawo) prawo.addEventListener('click', function () { przesun(1); });
  }

  function initAll() {
    document.querySelectorAll('[data-pp-ugc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
